import { ResourcesData as data } from "../Dashboard/Resources/data";

export const ResourcesData = { ...data, title: "Any questions?" };
